<template>
  <div class="app-container">
    <el-button type="primary" size="small" @click="goback">返回</el-button>
    <!-- 顶部栏 -->
    <div class="topbar" style="padding-top: 20px">
      <div>
        <el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
                  @keyup.enter.native="search()" clearable/>

        <el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
                   style="margin-left: 10px" @click="search()">
          搜索
        </el-button>

      </div>
      <el-button size="small" type="primary" @click="export2Excel()">导出excel</el-button>
    </div>

    <el-table v-loading="loading" :data="tableData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column label="ID" prop="liveSignUserID" align="center"></el-table-column>
      <el-table-column label="签到者" align="center">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column label="签到时间" align="center">
        <template #default="scope">
          {{ scope.row.signTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="删除时间" align="center">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template #default="scope">
          <el-button :type="scope.row.isDeleted ? 'warning' : 'danger'" size="small" @click="handleDelete(scope.row)">
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination hide-on-single-page background :total="pageOpt.total" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.curPage" @current-change="currentPageChange"/>

  </div>
</template>

<script>
import {isVaild} from "@/utils/validate";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {deleteLiveSignUserOrBack, getLiveSignUserList} from "@/api/mai/liveManagement/liveManagement";
import {export_json_to_excel} from "@/vendor/Export2Excel";
import {getDisplayName} from "@/utils/userutil";

export default {
  name: "SignUserList",
  components: {UserInfo},
  created() {
    let queryID = this.$route.query.liveID
    let querySignMsgID = this.$route.query.liveSignMsgID
    if (isVaild(queryID)) {
      this.liveID = queryID
      this.liveSignMsgID = querySignMsgID
      this.getLiveSignUserList()
    }
  },
  data() {
    return {
      liveID: 0,
      liveSignMsgID: 0,
      tableData: [],
      pageOpt: {
        curPage: 0,
        pageSize: 10,
        total: 0
      },
      loading: false,
      searchValue: ""
    }
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getLiveSignUserList();
    },
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getLiveSignUserList()
    },
    getLiveSignUserList() {
      this.loading = true
      getLiveSignUserList({
        keyWord: this.searchValue,
        liveId: this.liveID,
        liveSignMsgId: this.liveSignMsgID,
        pageIndex: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize
      }).then(res => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.pageOpt.total = res.data.total
        })
        this.loading = false;
      })
    },
    handleDelete(entity) {
      deleteLiveSignUserOrBack({
        liveSignUserId: entity.liveSignUserID
      }).then(res => {
        handleRes(res, () => {
          this.getLiveSignUserList();
          this.$message('操作成功')
        })
      })
    },
    async getAllLiveSignUserList() {
      this.loading = true
      let res = await getLiveSignUserList({
        keyWord: this.searchValue,
        liveId: this.liveID,
        liveSignMsgId: this.liveSignMsgID,
        pageIndex: 1,
        pageSize: 0
      })
      this.loading = false
      return res
    },
    async export2Excel() {
      if (this.tableData.length === 0) {
        this.$message.info('没有要导出数据')
        return;
      }
      let {
        tName,
        tHeader,
        filterValue
      } = this.getExcelInfo()
      let res = await this.getAllLiveSignUserList()
      let list = this.formatTableData(res.data.rows)
      let data = this.formatJson(filterValue, list)
      export_json_to_excel({
        header: tHeader,
        data,
        filename: tName,
        autoWidth: true,
        bookType: "xlsx",
      })
    },
    getExcelInfo() {
      let tName = '签到记录';
      let tHeader;
      let filterValue;
      tHeader = ['ID', '直播ID', '用户ID', '签到ID', '签到时间', '昵称', '姓', '名', '全名']
      filterValue = [
        'liveSignUserID',
        'liveID',
        'userID',
        'liveSignMsgID',
        'signTime',
        'nickname',
        'firstName',
        'lastName',
        'fullName',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }
    },
    formatTableData(list) {
      let newList = list.map(item => {
        item.liveSignMsgID = this.liveSignMsgID
        item.signTime = this.$options.filters["formatDateTime"](item.signTime)
        item.fullName = `${item.firstName}${item.lastName}`
        return item
      })

      return newList
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
  }
}
</script>

<style scoped>

</style>